var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "standart_mem clr" },
    [
      _c("standart", {
        key: "trip_addon",
        attrs: {
          title: "Відрядження",
          is_active_result: false,
          is_active_problem: false,
        },
        scopedSlots: _vm._u([
          {
            key: "mem_preamblua",
            fn: function () {
              return [
                _c(
                  "b-row",
                  { staticClass: "doc_title", attrs: { id: "vac_text" } },
                  [
                    _c("b-col", { attrs: { sm: "3" } }, [
                      _c("label", { attrs: { for: "vac_text" } }, [
                        _vm._v("текст відрядження *"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            placeholder: _vm.placeholder,
                            "editor-toolbar": _vm.editor_rules,
                            id: "trip_preamblua",
                          },
                          model: {
                            value: _vm.mem_preamblua,
                            callback: function ($$v) {
                              _vm.mem_preamblua = $$v
                            },
                            expression: "mem_preamblua",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("legend", [_vm._v("Маршрут")]),
      _vm._v(" "),
      _c("div", { staticClass: "trip_data" }, [
        _c(
          "div",
          { staticClass: "head row" },
          [
            _vm._l(_vm.addon_fields, function (head) {
              return _c("div", { staticClass: "field", class: head.class }, [
                _c("div", { staticClass: "title_min" }, [
                  _vm._v(_vm._s(head.name)),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "clr" }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("b-container", { attrs: { fluid: "" } }, [
        _c(
          "div",
          { staticClass: "after_change" },
          _vm._l(_vm.form.trip_fileds, function (row, idx) {
            return _c(
              "div",
              { staticClass: "action_field row" },
              [
                _vm._l(_vm.addon_fields, function (item, idx2) {
                  return _c(
                    "div",
                    { staticClass: "field_insert", class: item.class },
                    [
                      item.insert_val === "date_from"
                        ? _c("date-picker", {
                            attrs: {
                              "value-type": "format",
                              lang: _vm.d_lang,
                              confirm: "",
                              "first-day-of-week": 1,
                            },
                            model: {
                              value: _vm.form.trip_fileds[idx][idx2].value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.trip_fileds[idx][idx2],
                                  "value",
                                  $$v
                                )
                              },
                              expression: "form.trip_fileds[idx][idx2].value",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "adv_selects" },
                        [
                          _vm.is_select(_vm.form.trip_fileds[idx][idx2])
                            ? _c("b-form-select", {
                                attrs: {
                                  options: _vm.form.trip_fileds[idx][idx2].adv,
                                },
                                model: {
                                  value: _vm.form.trip_fileds[idx][idx2].value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.trip_fileds[idx][idx2],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.trip_fileds[idx][idx2].value",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.can_add(_vm.form.trip_fileds[idx][idx2])
                            ? _c("i", {
                                staticClass: "fa fa-plus-square",
                                attrs: { id: _vm.get_uniq(idx, idx2) },
                                on: {
                                  click: function ($event) {
                                    return _vm.show_editor(idx, idx2)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.can_add(_vm.form.trip_fileds[idx][idx2])
                            ? _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: _vm.get_uniq(idx, idx2),
                                    triggers: "click",
                                    show: _vm.form.trip_fileds[idx][idx2]
                                      .show_popup,
                                    placement: "auto",
                                    container: "my-container",
                                  },
                                  on: {
                                    "update:show": function ($event) {
                                      return _vm.$set(
                                        _vm.form.trip_fileds[idx][idx2],
                                        "show_popup",
                                        $event
                                      )
                                    },
                                    show: function ($event) {
                                      return _vm.onShow(
                                        _vm.form.trip_fileds[idx][idx2]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "title" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "close",
                                          attrs: { "aria-label": "Close" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClose(
                                                _vm.form.trip_fileds[idx][idx2]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-inline-block",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                Додати пункт\n                            "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-1",
                                          attrs: {
                                            label: "Текст",
                                            "label-for": "popover-input-1",
                                            "label-cols": "3",
                                            state: _vm.popoverInputState(
                                              _vm.form.trip_fileds[idx][idx2]
                                            ),
                                            description: "Введіть пункт",
                                            "invalid-feedback":
                                              "Цей пункт є обовязковим",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "popover-input-1",
                                              state: _vm.popoverInputState(
                                                _vm.form.trip_fileds[idx][idx2]
                                              ),
                                              size: "sm",
                                            },
                                            model: {
                                              value:
                                                _vm.form.trip_fileds[idx][idx2]
                                                  .popup_value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.trip_fileds[idx][
                                                    idx2
                                                  ],
                                                  "popup_value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.trip_fileds[idx][idx2].popup_value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOk(idx, idx2)
                                            },
                                          },
                                        },
                                        [_vm._v("Додати")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "remove_row",
                    on: {
                      click: function ($event) {
                        return _vm.remove_row(idx)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-trash-o active",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clr" }),
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control title_ mt-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-success",
            on: {
              click: function ($event) {
                return _vm.add_row()
              },
            },
          },
          [_vm._v("Додати")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }